
import React from 'react';

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "/src/node_modules/@storybook/addon-docs/dist/shims/mdx-react-shim.mjs";
import {css} from '@emotion/css';
import {Meta, Canvas} from '@storybook/blocks';
import {PanelChrome} from './PanelChrome';
import {action} from '@storybook/addon-actions';
import {LoadingState} from '@grafana/data';
import {Button} from '../Button';
import {Menu} from '../Menu/Menu';
import {Stack} from '../Layout/Stack/Stack';
import {IconButton} from '../IconButton/IconButton';
import * as PanelChromeStories from './PanelChrome.story';
import {ExampleFrame} from '../../utils/storybook/ExampleFrame';
function _createMdxContent(props) {
  const _components = {
    blockquote: "blockquote",
    code: "code",
    div: "div",
    em: "em",
    h1: "h1",
    h3: "h3",
    h4: "h4",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  if (!PanelChrome) _missingMdxReference("PanelChrome", false);
  if (!PanelChrome.LoadingIndicator) _missingMdxReference("PanelChrome.LoadingIndicator", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Meta, {
      title: "MDX|PanelChrome",
      component: PanelChrome
    }), "\n", _jsx(_components.h1, {
      id: "panelchrome",
      children: "PanelChrome"
    }), "\n", _jsx(_components.p, {
      children: "Component used for rendering content wrapped in the same style as grafana panels"
    }), "\n", _jsx(_components.h3, {
      id: "basic-usage-title-description-and-content",
      children: "Basic Usage: Title, Description and Content"
    }), "\n", _jsx(Canvas, {
      of: PanelChromeStories.Basic
    }), "\n", _jsx(_components.h3, {
      id: "menu-standard--hover",
      children: "Menu: Standard & Hover"
    }), "\n", _jsx(ExampleFrame, {
      children: _jsxs(Stack, {
        gap: 2,
        alignItems: "flex-start",
        wrap: "wrap",
        children: [_jsx(PanelChrome, {
          title: "My awesome panel title",
          menu: () => _jsxs(Menu, {
            children: [_jsx(Menu.Item, {
              label: "View",
              icon: "eye"
            }), _jsx(Menu.Item, {
              label: "Edit",
              icon: "edit"
            }), _jsx(Menu.Item, {
              label: "Share",
              icon: "share-alt"
            }), _jsx(Menu.Divider, {}), _jsx(Menu.Item, {
              label: "Remove",
              icon: "trash-alt"
            })]
          }),
          description: "Here I will put a description that explains a bit more this panel",
          width: 400,
          height: 200,
          children: (innerwidth, innerheight) => {
            return _jsx(_components.div, {
              style: {
                width: innerwidth,
                height: innerheight,
                background: 'rgba(230,0,0,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: "Content with fixed header"
            });
          }
        }), _jsx(PanelChrome, {
          title: "My awesome panel title",
          menu: () => _jsxs(Menu, {
            children: [_jsx(Menu.Item, {
              label: "View",
              icon: "eye"
            }), _jsx(Menu.Item, {
              label: "Edit",
              icon: "edit"
            }), _jsx(Menu.Item, {
              label: "Share",
              icon: "share-alt"
            }), _jsx(Menu.Divider, {}), _jsx(Menu.Item, {
              label: "Remove",
              icon: "trash-alt"
            })]
          }),
          hoverHeader: true,
          description: "Here I will put a description that explains a bit more this panel",
          width: 400,
          height: 200,
          children: (innerwidth, innerheight) => {
            return _jsx(_components.div, {
              style: {
                width: innerwidth,
                height: innerheight,
                background: 'rgba(230,0,0,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: "Content with hoverHeader=true"
            });
          }
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "states-loading--streaming-error",
      children: "States: Loading , Streaming, Error"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<PanelChrome\n  title=\"My awesome panel title\"\n  loadingState={<Loading.Loading || Loading.Streaming>}\n  statusMessage='Error text'\n  statusMessageOnClick={action('ErrorIndicator: onClick fired')}\n  width={400}\n  height={200}\n>\n  {(innerwidth, innerheight) => {\n    return (\n      <div\n        style={{\n          width: innerwidth,\n          height: innerheight,\n          background: 'rgba(230,0,0,0.05)',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        New panel with old API\n      </div>\n    );\n  }}\n</PanelChrome>\n"
      })
    }), "\n", _jsx(ExampleFrame, {
      children: _jsxs(Stack, {
        gap: 2,
        alignItems: "flex-start",
        wrap: "wrap",
        children: [_jsx(PanelChrome, {
          title: "My awesome panel title",
          loadingState: LoadingState.Loading,
          width: 400,
          height: 200,
          children: (innerwidth, innerheight) => {
            return _jsx(_components.div, {
              style: {
                width: innerwidth,
                height: innerheight,
                background: 'rgba(230,0,0,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: "Data is loading"
            });
          }
        }), _jsx(PanelChrome, {
          title: "My awesome panel title",
          loadingState: LoadingState.Streaming,
          width: 400,
          height: 200,
          children: (innerwidth, innerheight) => {
            return _jsx(_components.div, {
              style: {
                width: innerwidth,
                height: innerheight,
                background: 'rgba(230,0,0,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: "Data is Streaming"
            });
          }
        }), _jsx(PanelChrome, {
          title: "My awesome panel title",
          statusMessage: "Error text",
          statusMessageOnClick: action('ErrorIndicator: onClick fired'),
          width: 400,
          height: 200,
          children: (innerwidth, innerheight) => {
            return _jsx(_components.div, {
              style: {
                width: innerwidth,
                height: innerheight,
                background: 'rgba(230,0,0,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: "There is an error"
            });
          }
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "extra-options-title-items-and-actions",
      children: "Extra options? Title items and actions"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<PanelChrome\n  title=\"My awesome panel title\"\n  titleItems={\n    <>\n      <IconButton\n        className={css`\n          margin-right: 10px;\n        `}\n        name=\"github\"\n        variant=\"secondary\"\n        tooltip=\"extra content to render\"\n      />\n      <IconButton name=\"sliders-v-alt\" variant=\"secondary\" tooltip=\"extra content2 to render\" />\n    </>\n  }\n  actions={\n    <Button size=\"sm\" variant=\"secondary\" key=\"A\">\n      Breakdown\n    </Button>\n  }\n  width={500}\n  height={200}\n>\n  {(innerwidth, innerheight) => {\n    return (\n      <div\n        style={{\n          width: innerwidth,\n          height: innerheight,\n          background: 'rgba(230,0,0,0.05)',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        New panel with old API\n      </div>\n    );\n  }}\n</PanelChrome>\n"
      })
    }), "\n", _jsx(ExampleFrame, {
      children: _jsx(PanelChrome, {
        title: "My awesome panel title",
        titleItems: _jsxs(_Fragment, {
          children: [_jsx(IconButton, {
            className: css`
            margin-right: 10px;
          `,
            name: "github",
            variant: "secondary",
            tooltip: "extra content to render"
          }), _jsx(IconButton, {
            name: "sliders-v-alt",
            variant: "secondary",
            tooltip: "extra content to render"
          })]
        }),
        actions: _jsx(Button, {
          size: "sm",
          variant: "secondary",
          children: "Breakdown"
        }, "A"),
        width: 500,
        height: 200,
        children: (innerwidth, innerheight) => {
          return _jsx(_components.div, {
            style: {
              width: innerwidth,
              height: innerheight,
              background: 'rgba(230,0,0,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "Content"
          });
        }
      })
    }), "\n", _jsx(_components.h3, {
      id: "migration-from-old-panelchrome-before-v940",
      children: "Migration from old PanelChrome (before v9.4.0)"
    }), "\n", _jsx(_components.h4, {
      id: "before",
      children: "Before"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<PanelChrome\n  title=\"My awesome panel title\"\n  leftItems={[<PanelChrome.LoadingIndicator loading={isRefreshing} onCancel={onCancelQuery} key=\"loading-indicator\" />]}\n  width={400}\n  height={200}\n>\n  {(innerwidth, innerheight) => {\n    return (\n      <div\n        style={{\n          width: innerwidth,\n          height: innerheight,\n          background: 'white',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        New panel with old API\n      </div>\n    );\n  }}\n</PanelChrome>\n"
      })
    }), "\n", _jsx(ExampleFrame, {
      children: _jsx(PanelChrome, {
        title: "My awesome panel title",
        leftItems: [_jsx(PanelChrome.LoadingIndicator, {
          loading: true,
          onCancel: action('CancelQuery: onClick fired')
        }, "loading-indicator")],
        width: 400,
        height: 200,
        children: (innerwidth, innerheight) => {
          return _jsx(_components.div, {
            style: {
              width: innerwidth,
              height: innerheight,
              background: 'rgba(230,0,0,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "Content"
          });
        }
      })
    }), "\n", _jsx(_components.h4, {
      id: "after",
      children: "After"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<PanelChrome\n  title=\"My awesome panel title\"\n  loadingState={LoadingState.Loading}\n  onCancelQuery={onCancelQuery}\n  width={400}\n  height={200}\n>\n  {(innerwidth, innerheight) => {\n    return (\n      <div\n        style={{\n          width: innerwidth,\n          height: innerheight,\n          background: 'white',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        New panel with old API\n      </div>\n    );\n  }}\n</PanelChrome>\n"
      })
    }), "\n", _jsx(ExampleFrame, {
      children: _jsx(PanelChrome, {
        title: "My awesome panel title",
        loadingState: LoadingState.Loading,
        onCancelQuery: action('CancelQuery: onClick fired'),
        width: 400,
        height: 200,
        children: (innerwidth, innerheight) => {
          return _jsx(_components.div, {
            style: {
              width: innerwidth,
              height: innerheight,
              background: 'rgba(230,0,0,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "Content"
          });
        }
      })
    }), "\n", _jsx(_components.h3, {
      id: "collapsible",
      children: "Collapsible"
    }), "\n", _jsx(_components.p, {
      children: "The panel can be collapsed/expanded by clicking on the chevron or the title."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["Note: ", _jsx(_components.code, {
            children: "collapsible"
          }), " and ", _jsx(_components.code, {
            children: "hoverHeader"
          }), " props are mutually exclusive and cannot be used in the same panel."]
        })
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "function Container() {\n  const [isCollapsed, setCollapsed] = useState(true);\n\n  return (\n    <PanelChrome\n      title=\"My awesome panel title\"\n      width={400}\n      height={200}\n      collapsible={true}\n      collapsed={isCollapsed}\n      onToggleCollapse={(isCollapsed) => setCollapsed(isCollapsed)}\n    >\n      {(innerwidth, innerheight) => {\n        return (\n          <div\n            style={{\n              width: innerwidth,\n              height: innerheight,\n              background: 'rgba(230,0,0,0.05)',\n              display: 'flex',\n              alignItems: 'center',\n              justifyContent: 'center',\n            }}\n          >\n            Content\n          </div>\n        );\n      }}\n    </PanelChrome>\n  );\n}\n"
      })
    }), "\n", _jsx(ExampleFrame, {
      children: _jsx(PanelChrome, {
        title: "My awesome panel title",
        width: 400,
        height: 200,
        collapsible: true,
        children: (innerwidth, innerheight) => {
          return _jsx(_components.div, {
            style: {
              width: innerwidth,
              height: innerheight,
              background: 'rgba(230,0,0,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "Content"
          });
        }
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
